import { render, staticRenderFns } from "./LongRedirect.vue?vue&type=template&id=34b062bc&scoped=true&"
import script from "./LongRedirect.vue?vue&type=script&lang=js&"
export * from "./LongRedirect.vue?vue&type=script&lang=js&"
import style0 from "./LongRedirect.vue?vue&type=style&index=0&id=34b062bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b062bc",
  null
  
)

export default component.exports